import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { detectionApi } from "../http/Api";

export const getDetection = createAsyncThunk(
  "Detection/getDetection",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await detectionApi.getDetection(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(detectionSlice.actions.setDetection(response));
    }
  }
);

export const getDetectionAdvanced = createAsyncThunk(
  "Detection/getDetectionAdvanced",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await detectionApi.getDetectionAdvanced(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(detectionSlice.actions.setDetectionAdvanced(response));
    }
  }
);

export const getDetectionLogs = createAsyncThunk(
  "Detection/getDetectionLogs",
  async (_, thunkAPI) => {
    const {serverId} = thunkAPI.getState().serverId;
    const response = await detectionApi.getLogs(serverId);
    console.log("response", response);

    if (response.status === 200) {
      thunkAPI.dispatch(detectionSlice.actions.setDetectionLogs(response));
    }
  }
);

const initialState = {
  detectionGlobalState: null,
  detectionAdvancedGlobalState: null,
  detectionLogsState: null,
};

const detectionSlice = createSlice({
  name: "detection",
  initialState,
  reducers: {
    setDetection: (state, action) => {
      state.detectionGlobalState = action.payload;
    },
    setDetectionAdvanced: (state, action) => {
      state.detectionAdvancedGlobalState = action.payload;
    },
    setDetectionLogs: (state, action) => {
      state.detectionLogsState = action.payload;
    },
  },
});

export const detection = detectionSlice.reducer;
